import React, { useState } from 'react';
import { ProgressDonut, ProgressColor, BackgroundColor } from '../ProgressDonut';
import { Panel, PanelTheme } from '../Panel';
import { DemoPage } from './common/DemoLayout';

export const ProgressDonutDemo: React.FC = () => {
    const [value, setValue] = useState(75);
    const [size, setSize] = useState(50);
    const [progressColor, setProgressColor] = useState<ProgressColor>(ProgressColor.Blue);
    const [backgroundColor, setBackgroundColor] = useState<BackgroundColor>(BackgroundColor.Grey);

    // Create an array of available colors from the enum.
    const colorOptions: ProgressColor[] = Object.values(ProgressColor);
    const bgColorOptions: BackgroundColor[] = Object.values(BackgroundColor);

    const decreaseValue = () => setValue((prev) => Math.max(prev - 5, 0));
    const increaseValue = () => setValue((prev) => Math.min(prev + 5, 100));

    const decreaseSize = () => setSize((prev) => Math.max(prev - 20, 50));
    const increaseSize = () => setSize((prev) => prev + 20);

    const cycleColor = () => {
        const currentIndex = colorOptions.indexOf(progressColor);
        const nextIndex = (currentIndex + 1) % colorOptions.length;
        setProgressColor(colorOptions[nextIndex]);
    };

    const cycleBgColor = () => {
        const currentIndex = bgColorOptions.indexOf(backgroundColor);
        const nextIndex = (currentIndex + 1) % colorOptions.length;
        setBackgroundColor(bgColorOptions[nextIndex]);
    };

    return (
        <DemoPage title='Progress Donut :'>
            <Panel
                theme={PanelTheme.White}
                width='88%'
            >
                <ProgressDonut
                    value={value}
                    size={size}
                    progressColor={progressColor}
                    backgroundColor={backgroundColor}
                />
                <div style={{ marginTop: '1rem' }}>
                    <button
                        onClick={decreaseValue}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Decrease Value
                    </button>
                    <button onClick={increaseValue}>Increase Value</button>
                </div>

                <div style={{ marginTop: '1rem' }}>
                    <button
                        onClick={decreaseSize}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Decrease Size
                    </button>
                    <button onClick={increaseSize}>Increase Size</button>
                </div>

                <div style={{ marginTop: '1rem' }}>
                    <button onClick={cycleColor}>Cycle Color</button>
                </div>
                <div style={{ marginTop: '1rem' }}>
                    <button onClick={cycleBgColor}>Cycle Background Color</button>
                </div>
            </Panel>
        </DemoPage>
    );
};
